import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ApiProxy extends BaseProxy implements ProxyMethods {
  public endpoint = ''

  requestCreate(data: any) {
    return this.submit('post', `${this.endpoint}/user-registration-request`, data)
  }

  getReportFile(file: string) {
    return this.submit('get', `${this.endpoint}/report-file?file=${file}`)
  }
}
